<template>
	<div class="tag-custom">
		<el-tag
			class="tag-item"
			:key="index"
			v-for="(tag,index) in dynamicTags"
			closable
			:disable-transitions="true"
			@close="handleClose(tag)">
			{{tag}}
		</el-tag>

		<el-input
			class="input-new-tag"
			v-if="inputVisible"
			v-model="inputValue"
			ref="saveTagInput"
			@keyup.enter.native="handleInputConfirm"
			@blur="handleInputConfirm"
			maxlength="6"
			@input="change"
		></el-input>

		<el-button v-else class="add" size="small" @click="showInput" :disabled="dynamicTags.length>=max">+ 添加
		</el-button>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				dynamicTags: this.value || [],
				inputVisible: false,
				inputValue: ''
			};
		},
		methods: {
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
				this.$emit('input', this.dynamicTags)
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				let inputValue = this.inputValue;
				if (inputValue) {
					this.dynamicTags.push(inputValue);
				}
				this.inputVisible = false;
				this.inputValue = '';
				this.$emit('input', this.dynamicTags)
			},
			change(val) {
				let inputValue = this.inputValue;
				inputValue = inputValue.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g, '')
				this.$nextTick(() => {
					this.inputValue = inputValue
				})
			}
		},
		props: {
			max: {
				type: Number,
				default: 0
			},
			value: {
				type: Array
			},


		},
		watch: {
			'value': function (newValue) {
				this.dynamicTags = newValue
			}
		},
	}
</script>

<style scoped>
	.button-new-tag {
		/*margin-left: 10px;*/
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;

	}

	.input-new-tag {
		width: 120px;
		/*margin-left: 10px;*/
		vertical-align: bottom;
	}

	.tag-item {
		line-height: 32px;
		height: 32px;
		margin-right: 10px;

	}

	.tag-custom {
		display: inline-block;
	}

	.add {
		width: 90px;

	}

</style>



// WEBPACK FOOTER //
// src/views/components/mutiTag.vue